import { type ReactNode } from 'react'
import { LogoPreLoader } from '@/shared/ui/icons'

export interface SpinnerProps {
  isLoading?: boolean | string | null
  children?: ReactNode
  fullScreen?: boolean
  /** @deprecated Use fullScreen instead */
  fullscreen?: boolean
  position?: 'absolute' | 'relative' | 'fixed'
  top?: string
  left?: string
  right?: string
  bottom?: string
  /** Maps to LogoPreLoader width: small 48 / medium 72 / large 120 */
  size?: 'small' | 'medium' | 'large'
  /** Minimum container height when not fullScreen. Defaults to 300 so modals don't collapse. */
  minHeight?: number | string
  height?: string
}

const SIZE_PX: Record<NonNullable<SpinnerProps['size']>, number> = {
  small: 48,
  medium: 72,
  large: 120,
}

export function Spinner({
  isLoading = false,
  children,
  fullScreen = false,
  position = 'relative',
  top,
  size = 'medium',
  minHeight = 300,
  height,
}: SpinnerProps) {
  if (!isLoading) return <>{children}</>

  const px = SIZE_PX[size]

  return (
    <div
      className="flex items-center justify-center w-full"
      style={{
        position: fullScreen ? 'fixed' : position,
        top: top ?? (fullScreen ? 0 : undefined),
        left: fullScreen ? 0 : undefined,
        right: fullScreen ? 0 : undefined,
        bottom: fullScreen ? 0 : undefined,
        zIndex: fullScreen ? 9999 : undefined,
        height: fullScreen ? '100vh' : height,
        minHeight: fullScreen ? undefined : minHeight,
        backgroundColor: fullScreen ? 'rgba(255,255,255,0.7)' : undefined,
      }}
    >
      <LogoPreLoader style={{ width: px, height: 'auto' }} />
    </div>
  )
}
